/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Statement_BsInputs */

const en_statement_taxonomy_editor_statement_bs = /** @type {(inputs: Statement_Taxonomy_Editor_Statement_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance sheet`)
};

const nl_statement_taxonomy_editor_statement_bs = /** @type {(inputs: Statement_Taxonomy_Editor_Statement_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balans`)
};

/**
* | output |
* | --- |
* | "Balance sheet" |
*
* @param {Statement_Taxonomy_Editor_Statement_BsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_statement_bs = /** @type {((inputs?: Statement_Taxonomy_Editor_Statement_BsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Statement_BsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_statement_bs(inputs)
	return en_statement_taxonomy_editor_statement_bs(inputs)
});